import React from 'react';
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';

export const CustomAccordion = ({ id, tittle, icon, children }) => {
  return (
    <AccordionItem key={id} uuid={id}>
      <AccordionItemHeading>
        <AccordionItemButton>
          <i className={icon}></i> <strong>{tittle}</strong>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="table-responsive">
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Title</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>{children}</tbody>
          </table>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};
